export default __webpack_public_path__ + "static/takai-6070e33e5dab80ce6ef01b4c1b0febca.svg";